
export const Screens = {
  SEARCH: 'search',
  EDIT: 'edit',
  LOGIN: 'login'
};
